<app-header></app-header>
<!-- Middle Content CSS End Here  -->
<div class="middle-content-wrap">
  <!-- Dashboard HTML Start Here  -->
  <div class="globalheading dflex dflex_bet">



    <h2>
      <span (click)="navigateBackToList()" class="breadcumbs" style="cursor: pointer;">Customers</span> <span
        class="navigation-arrow">></span>
      <span>{{status.toUpperCase()}} Customer
        Details</span>
    </h2>
  </div>
  <div class="rejectionReason" *ngIf="status=='rejected'">
    Rejection Reason :
    <div class="activebtn">
      <button type="button" class="btnActive"
        style="background-color: rgb(244, 62, 62); color: #faf6ed;">{{personalDetails?.rejection_reason ||
        'NotGiven'}}</button>
    </div>
  </div>

  <!-- Active Filter Chips Display -->
  <div class="filter-chips-container" *ngIf="getActiveFiltersCount() > 0">
    <div class="filter-chips">
      <span class="filter-chip" *ngFor="let chip of getActiveFilterChips()">
        <span class="chip-label">{{chip.label}}:</span>
        <span class="chip-value">{{chip.value}}</span>
      </span>
    </div>
  </div>

  <div *ngIf="loadingConnectionDataItems" class="loader"></div>

  <div *ngIf="!loadingConnectionDataItems" class="customer-detial-view">
    <div style="display: flex; justify-content: space-between;padding:10px">
      <button (click)="moveToPrevUser()" [disabled]="!prev_user_id" style="cursor: pointer;"><i class="fa fa-arrow-left"
          aria-hidden="true"></i></button>
      <button (click)="moveToNextUser()" [disabled]=" !next_user_id" style="cursor: pointer;"><i
          class="fa fa-arrow-right" aria-hidden="true"></i></button>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="user-detail-card user-detail-view-card userdetail-view">
          <div class="user-img-wrap"
            *ngIf="personalDetails?.selfie == null  || personalDetails?.selfie == ''  ; else profile ">
            <img src="assets/images/userimg.png" />
          </div>
          <ng-template #profile>
            <div class="user-img-wrap">
              <img src="{{ personalDetails?.selfie}}" />
            </div>
          </ng-template>



          <div class="dflex dflex_bet">
            <div class="user-card-left">
              <!-- <span>&nbsp;Connect ID : {{ userInfo?.userProfileNo || 'NA' }}</span> -->

              <div class="d-flex username_div">
                <p>{{ personalDetails?.name || "N/A" }} ({{ aboutYourself?.occupation || 'Occupation N/A'}}) </p>
                <div class="d-flex">
                  <div class="verifyed_user_text">
                    <button class="notverify" *ngIf="userInfo?.verifyStatus == ''">
                      Not Verified
                    </button>
                    <button class="notverify" *ngIf="userInfo?.verifyStatus == 'No'">
                      Not Verified
                    </button>
                    <button *ngIf="userInfo?.verifyStatus == 'Yes'">
                      Verified
                      <img src="assets/images/verified.svg" alt="">
                    </button>
                  </div>

                  <div class="premium_user_text">

                    <ng-template #premiumText>
                      <button>
                        Life Time Access /Monthly Access
                        <img src="assets/images/premium.svg" alt="">
                      </button>
                    </ng-template>
                  </div>
                </div>
              </div>

              <div class="userextrainfo">
                <ul>
                  <li>
                    <img src="assets/images/gender-icon.svg" alt="" />
                    <span>{{ personalDetails?.gender || "N/A" }}</span>
                  </li>
                  <li>
                    <img src="assets/images/email-icon.svg" alt="" />
                    <span>{{ personalDetails?.email || "N/A" }}</span>
                  </li>
                  <li>
                    <img src="assets/images/contact-icon.svg" alt="" />
                    <span> {{ personalDetails?.phone || "N/A" }}</span>
                  </li>
                  <li>
                    <img src="assets/images/time.svg" alt="" />

                    <span>{{personalDetails?.registrationDate | date:'medium' }}</span>
                  </li>
                  <li>
                    <img src="assets/images/time.svg" alt="" />
                    <span>Last Login: {{ personalDetails?.lastLogin ? (personalDetails.lastLogin | date:'medium') :
                      'N/A' }}</span>
                  </li>
                  <li>
                    <span>Attractive Score: {{ attractivenessScore !== undefined ? attractivenessScore : 'N/A' }}</span>
                  </li>
                  <li>
                    <span>Activity Score: {{ activityScore !== undefined ? activityScore : 'N/A' }}</span>
                  </li>
                  <li>
                    <span>Tier: {{ personalDetails?.tier_name ? personalDetails.tier_name : 'TIER1' }}</span>
                  </li>
                </ul>
              </div>



            </div>
            <div class="user-card-right d-flex ">
              <div class="statusshow" *ngIf="profileStatus?.status == 'Pending' || profileStatus?.status == 'Verified'">
                Status :
                <div class="activebtn">
                  <button type="button" class="btnActive"
                    [ngStyle]="{'background-color': profileStatus?.status == 'Pending' ? '#f3d07766' : '#76f16c66', 'color': profileStatus?.status == 'Pending' ? '#df930a' : '#02b708'}">
                    {{ profileStatus?.status }}
                  </button>
                </div>
              </div>
              <div class="user-action-buttons" style="align-items: center;" *ngIf="!isManager">
                <div class="notification">
                  <button class="btn btn-dark" data-toggle="modal" data-target="#deletModal"> Send Notification</button>
                </div>
                <div style="margin-left: 10px;">
                  <button class="btn btn-dark" (click)="openEditCustomerModal()">
                    <i class="fa fa-edit"></i> Edit Details
                  </button>
                </div>
              </div>
              <div class="user-action-buttons" style="flex-basis: 100%;margin-top: 10px; gap:10px;justify-content: end;"
                *ngIf="display_reject_approve_buttons && !isManager">
                <button
                  *ngIf="(status=='unapproved' || status=='tier2' || status=='auto-approval' || status=='auto-rejected') &&  !personalDetails.adminVerification"
                  class="btn btn-green" data-toggle="modal" (click)="openApproveModal()">Approve as TIER1
                </button>
                <button
                  *ngIf="(status=='unapproved' || status=='tier2' || status=='auto-approval' || status=='auto-rejected') && !personalDetails.adminVerification "
                  class="btn btn-dark" data-toggle="modal" (click)="openTier2ApproveModal()">Approve as TIER2</button>
                <button *ngIf="(status=='approved' || status=='rejected')" class="btn btn-warning" data-toggle="modal"
                  (click)="openUnapproveModal()">Move To
                  Waitlist</button>
                <button *ngIf="(status!='rejected' && status!='archived')" class="btn btn-danger" data-toggle="modal"
                  (click)="openRejectModal()">Reject </button>
                <button *ngIf="status=='auto-approval'" class="btn btn-warning" data-toggle="modal"
                  (click)="openRemoveFromAutoApprovalModal()">Remove From Auto Approval</button>
                <button
                  *ngIf="(status=='rejected' || status=='unapproved' || status=='archived' || status=='auto-rejected') && !userMovedToTier2"
                  class="btn btn-dark" data-toggle="modal" (click)="openMoveToTier2Modal()">Move to TIER2</button>
              </div>

            </div>
          </div>

        </div>

      </div>
    </div>
    <div class="basic-detail-view">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <div class="user-detail-card user-detail-view-card half-row">
                <span>Personal Details</span>
                <ul>
                  <li>
                    <a href="javascript:void(0);"><img src="assets/images/about-icon.svg" alt="" /><span>Name:
                        {{ personalDetails?.name || 'N/A' }}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><img src="assets/images/about-icon.svg" alt="" /><span>Email:
                        {{ personalDetails?.email || 'N/A' }}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><img src="assets/images/user-icon.svg" alt="" /><span>Gender:
                        {{ personalDetails?.gender || 'N/A' }}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><img src="assets/images/about-icon.svg" alt="" /><span>Phone No.:
                        {{ personalDetails?.phone || 'N/A' }}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" *ngIf="personalDetails?.profileCreatedOn; else naText"><img
                        src="assets/images/about-icon.svg" alt="" /><span>Profile Created Date:
                        {{ personalDetails?.profileCreatedOn | date:'medium'}}</span></a>
                    <ng-template #naText>
                      <a href="javascript:void(0);"><img src="assets/images/about-icon.svg" alt="" /><span>Profile
                          Created
                          Date:
                          {{ personalDetails?.profileCreatedOn || 'N/A' }}</span></a>
                    </ng-template>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><img src="assets/images/about-icon.svg" alt="" /><span>Profile
                        Complete:
                        {{ personalDetails?.profileCompleted || 'N/A' }}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><img src="assets/images/about-icon.svg" alt="" /><span>Registration
                        Date:
                        {{ personalDetails?.registrationDate ? (personalDetails.registrationDate | date:'medium') :
                        'N/A' }}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><img src="assets/images/about-icon.svg" alt="" /><span>Last Login:
                        {{ personalDetails?.lastLogin ? (personalDetails.lastLogin | date:'medium') : 'N/A'
                        }}</span></a>
                  </li>
                  <li *ngIf="this.status == 'approved'">
                    <a href="javascript:void(0);"><img src="assets/images/about-icon.svg" alt="" /><span>Total Referral
                        :
                        {{ referralCount || 'N/A' }}</span></a>
                  </li>
                  <li *ngIf="this.status == 'approved'">
                    <a href="javascript:void(0);"><img src="assets/images/about-icon.svg" alt="" />
                      <div style="display: flex;">Marketing : <span *ngIf="this.marketStatus == 1; else showMarket">
                          Yes
                        </span>
                        <ng-template #showMarket>
                          No
                        </ng-template>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="user-detail-card user-detail-view-card half-row"
                *ngIf="status === 'approved' || status === 'unapproved'">
                <span>Membership Details (Total Subscriptions Done: {{userSubscription?.total_subscriptions}})</span>
                <button type="button" class="btnActive" *ngIf="userSubscription?.isScouted"
                  style="background-color: #76f16c66; color: #02b708;margin-left: 10px;">Scouted</button>

                <ul *ngIf="userSubscription?.plan_purchased; else noMembership">
                  <li>
                    <a href="javascript:void(0);"><span>Membership
                        Type:
                        {{ userSubscription?.plan_purchased }}</span></a>
                  </li>
                  <li *ngIf="userSubscription?.price">
                    <a href="javascript:void(0);"><span>Membership
                        Status:
                        {{ userSubscription?.price }} {{userSubscription?.currency}}</span></a>
                  </li>
                  <li *ngIf="userSubscription?.purchase_date">
                    <a href="javascript:void(0);"><span>Start Date:
                        {{ userSubscription?.purchase_date | date:'medium' }}</span></a>
                  </li>
                  <li *ngIf="userSubscription?.expiry_date">
                    <a href="javascript:void(0);"><span>End Date:
                        {{ userSubscription?.expiry_date | date:'medium' }}</span></a>
                  </li>
                  <li *ngIf="userSubscription?.hasCancelled !== undefined">
                    <a href="javascript:void(0);"><span>Auto Renewal:
                        {{ userSubscription?.hasCancelled ? 'No' : 'Yes' }}</span></a>
                  </li>
                </ul>
                <ng-template #noMembership>
                  <div style="display: flex; justify-content: space-between;">
                    <p>No Active Membership</p>
                    <button type="button" class="btn btn-dark" *ngIf="!isManager" (click)="openScoutModal()">Scout
                      Membership</button>
                  </div>
                </ng-template>
              </div>
              <!-- Connection data summary -->
              <div *ngIf="info?.connectionData" class="user-detail-card user-detail-view-card half-row"
                style="margin-top: 20px;">
                <span>Connection Data</span>
                <ul *ngIf="connectionDataItems.length > 0; else noConnectionData">
                  <li *ngFor="let item of connectionDataItems">
                    <a href="javascript:void(0);"><i [ngClass]="item.icon"></i><span>{{item.label}}:
                        {{item.value}}</span></a>
                  </li>
                </ul>
                <ng-template #noConnectionData>
                  <p class="mb-0">No connection data available</p>
                </ng-template>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="info?.dealbreakers">
            <div class="col-md-12">
              <div class="user-detail-card user-detail-view-card half-row">
                <span>Dealbreakers</span>
                <ul>
                  <li *ngIf="info.dealbreakers?.ageRange?.min && info.dealbreakers?.ageRange?.max">
                    <a href="javascript:void(0);">
                      <i class="fa fa-user"></i>
                      <span>Age Range: {{info.dealbreakers.ageRange.min}} - {{info.dealbreakers.ageRange.max}}</span>
                    </a>
                  </li>
                  <li *ngIf="info.dealbreakers.religions?.length > 0">
                    <a href="javascript:void(0);">
                      <i class="fa fa-book"></i>
                      <span>Religions: {{info.dealbreakers.religions.join(', ')}}</span>
                    </a>
                  </li>
                  <li *ngIf="info.dealbreakers.fitnessLevels?.length > 0">
                    <a href="javascript:void(0);">
                      <i class="fa fa-ambulance"></i>
                      <span>Fitness: {{info.dealbreakers.fitnessLevels.join(', ')}}</span>
                    </a>
                  </li>
                  <li *ngIf="info.dealbreakers.alcoholPreferences?.length > 0">
                    <a href="javascript:void(0);">
                      <i class="fa fa-heart"></i>
                      <span>Alcohol: {{info.dealbreakers.alcoholPreferences.join(', ')}}</span>
                    </a>
                  </li>
                  <li *ngIf="info.dealbreakers.smokingPreferences?.length > 0">
                    <a href="javascript:void(0);">
                      <i class="fa fa-fire"></i>
                      <span>Smoking: {{info.dealbreakers.smokingPreferences.join(', ')}}</span>
                    </a>
                  </li>
                  <li *ngIf="info.dealbreakers.maritalPreferences?.length > 0">
                    <a href="javascript:void(0);">
                      <i class="fa fa-venus-mars"></i>
                      <span>Marital Status: {{info.dealbreakers.maritalPreferences.join(', ')}}</span>
                    </a>
                  </li>
                  <li *ngIf="info.dealbreakers.childrenPreferences?.length > 0">
                    <a href="javascript:void(0);">
                      <i class="fa fa-child"></i>
                      <span>Children: {{info.dealbreakers.childrenPreferences.join(', ')}}</span>
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="user-detail-card user-detail-view-card half-row">
                <span>Dates Information</span>
                <ul>
                  <li>
                    <a href="javascript:void(0);"><i class="fa fa-calendar"></i><span>Planned Dates:
                        {{info?.totalDatesPlanned || '0'}}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><i class="fa fa-check-circle"></i><span>Completed Dates:
                        {{info?.totalDatesCompleted || '0'}}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><i class="fa fa-times-circle"></i><span>Cancelled Dates:
                        {{info?.totalDatesCancelled || '0'}}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><i class="fa fa-heart"></i><span>Likes Sent:
                        {{info?.totalLikesSent || '0'}}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><i class="fa fa-heart"></i><span>Likes Received:
                        {{info?.totalLikesReceived || '0'}}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><i class="fa fa-handshake"></i><span>Total Matches:
                        {{info?.totalMatches || '0'}}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><i class="fa fa-clock"></i><span>Days to First Match:
                        {{info?.daysToFirstMatch || '0'}}</span></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="user-detail-card user-detail-view-card half-row">
                <span>Dating Information</span>
                <ul>
                  <li>
                    <a href="javascript:void(0);"><img src="assets/images/datebirth.svg" alt="" /><span>Date of Birth:
                        {{formatDateOfBirth(datingInfo?.dateOfBirth)}}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><img src="assets/images/country.svg" alt="" /><span>Nationality:
                        {{datingInfo?.nationality || 'N/A'}}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><img src="assets/images/religion-icon.svg" alt="" /><span>Religion:
                        {{datingInfo?.religion || 'N/A'}}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><img src="assets/images/marriage-status.svg" alt="" /><span>Marital
                        Status:
                        {{datingInfo?.marital_status || 'N/A'}}</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);"><img src="assets/images/family-type.svg" alt="" /><span>Child Status:
                        {{datingInfo?.child_status || 'N/A'}}</span></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
        <div class="col-md-6">
          <div class="user-detail-card user-detail-view-card">
            <span>About Yourself</span>
            <ul>
              <li *ngIf="personalDetails?.voice_prompt"
                style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
                <audio controls [src]="personalDetails.voice_prompt"
                  style="width: 250px; margin-bottom: 5px; margin-top: 0px; border-radius: 8px; background: #f5f5f5;"></audio>
                <button type="button" class="btn btn-danger btn-sm" (click)="openDeleteAudioModal()"
                  style="height: 38px; width: 38px; padding: 0; display: flex; align-items: center; justify-content: center;">
                  <i class="fa fa-trash"></i>
                </button>
              </li>
              <li>
                <a href="javascript:void(0);">
                  <img class="alcoholcons" [src]="getImage(aboutYourself?.alcohol_consumption)"
                    alt="alcohol_consumption" />
                  <span>{{capitalizeFirstLetterOfEachWord('alcohol_consumption')}}:
                    {{formatData(aboutYourself?.alcohol_consumption)}}
                  </span>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);">
                  <img src="assets/images/height-icon.svg" alt="" />
                  <span>Height :
                    {{aboutYourself?.height?.[0]?.text || 'N/A'}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <img [src]="getImage(aboutYourself?.fitness)" alt="fitness" />
                  <span>{{capitalizeFirstLetterOfEachWord('fitness')}}:
                    {{formatData(aboutYourself?.fitness)}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <!-- <img [src]="getImage(aboutYourself?.hobbies)" alt="hobbies" /> -->
                  <img src="assets/images/about-icon.svg" alt="hobbies" />
                  <span>{{capitalizeFirstLetterOfEachWord('hobbies')}}:
                    {{formatData(aboutYourself?.hobbies)}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <img [src]="getImage(aboutYourself?.i_usually_wake_up_at)" alt="i_usually_wake_up_at" />
                  <span>{{capitalizeFirstLetterOfEachWord('i_usually_wake_up_at')}}:
                    {{formatData(aboutYourself?.i_usually_wake_up_at)}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <img [src]="getImage(aboutYourself?.interest)" alt="interest" />
                  <span>{{capitalizeFirstLetterOfEachWord('interest')}}:
                    {{formatData(aboutYourself?.interest)}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <img [src]="getImage(aboutYourself?.meet_vibes)" alt="meet_vibes" />
                  <span>{{capitalizeFirstLetterOfEachWord('meet_vibes')}}:
                    {{formatData(aboutYourself?.meet_vibes)}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <img [src]="getImage(aboutYourself?.personality)" alt="personality" />
                  <span>{{capitalizeFirstLetterOfEachWord('personality')}}:
                    {{formatData(aboutYourself?.personality)}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <img [src]="getImage(aboutYourself?.smoker)" alt="smoker" />
                  <span>{{capitalizeFirstLetterOfEachWord('smoker')}}:
                    {{formatData(aboutYourself?.smoker?.name)}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <img [src]="getImage(aboutYourself?.values)" alt="values" />
                  <span>{{capitalizeFirstLetterOfEachWord('values')}}:
                    {{formatData(aboutYourself?.values)}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <img [src]="getImage(aboutYourself?.you_are_on_maxion_for)" alt="you_are_on_maxion_for" />
                  <span>{{capitalizeFirstLetterOfEachWord('you_are_on_maxion_for')}}:
                    {{formatData(aboutYourself?.you_are_on_maxion_for)}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <img [src]="getImage(aboutYourself?.your_life_goals)" alt="your_life_goals" />
                  <span>{{capitalizeFirstLetterOfEachWord('your_life_goals')}}:
                    {{formatData(aboutYourself?.your_life_goals)}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <img [src]="getImage(aboutYourself?.your_life_goals)" alt="your_life_goals" />
                  <span>{{capitalizeFirstLetterOfEachWord('gender_preference')}}:
                    {{aboutYourself?.gender_preference || 'N/A'}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <img [src]="getImage(aboutYourself?.your_life_goals)" alt="your_life_goals" />
                  <span>{{capitalizeFirstLetterOfEachWord('connection_pitch')}}:
                    {{aboutYourself?.connection_pitch || 'N/A'}}
                  </span>
                </a>
              </li>

              <li>
                <a href="javascript:void(0);">
                  <img [src]="getImage(aboutYourself?.your_life_goals)" alt="your_life_goals" />
                  <span>{{capitalizeFirstLetterOfEachWord('occupation')}}:
                    {{aboutYourself?.occupation || 'N/A'}}
                  </span>
                </a>
              </li>
            </ul>
          </div>
          <div class="user-detail-card user-detail-view-card">
            <span>New Connections</span>
            <div *ngIf="!connectionDetailsLoaded" class="text-center p-3">
              <button class="btn btn-dark" (click)="loadConnectionData()" [disabled]="isLoadingConnections">
                <i class="fa fa-refresh fa-spin" *ngIf="isLoadingConnections"></i>
                {{ isLoadingConnections ? 'Loading...' : 'Load Connection Data' }}
              </button>
            </div>
            <app-customer-new-connections *ngIf="connectionDetailsLoaded" [newConnections]="newConnectionsSummary"
              [detailStatus]="status"></app-customer-new-connections>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="listingformat">
          <span>Uploads</span>
          <div class="tabledatawrap">
            <div class="user-images-wrap">
              <span>Photos</span>
              <div class="user-pic-wrap">
                <ul *ngIf="this.userImages?.length > 0">
                  <li *ngFor="let item of userImages">
                    <div class="userimage-upload">
                      <img (click)="imageData($event , item)" data-toggle="modal" data-target="#photoModal"
                        [src]="item" />
                    </div>
                  </li>
                </ul>

                <ul *ngIf="this.userImages?.length == 0">
                  <ul>
                    <li>
                      <div class="userimage-upload">
                        <img src="assets/images/Ellipse 24@2x.png" />
                      </div>
                    </li>
                  </ul>
                </ul>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-7">
               
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="listingformat">
          <span>Social Details</span>
          <div class="tabledatawrap">
            <div class="form-group">
              <p>Name : <strong>{{socialDetails?.name}}</strong></p>
            </div>
            <div class="form-group">
              <p>Email : <strong>{{socialDetails?.email}}</strong></p>
            </div>
            <div class="form-group">
              <p>Social Type : <strong>{{socialDetails?.social_type}}</strong></p>
            </div>
            <div class="form-group">
              <p>Url : <a
                  [href]="socialDetails?.url?.startsWith('http://') || socialDetails?.url?.startsWith('https://') ? socialDetails?.url : 'https://' + socialDetails?.url"
                  target="_blank"><strong>{{socialDetails?.url}}</strong></a></p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="listingformat paymenthistory">
          <span>ID Verification Details</span>
          <div class="tabledatawrap">
            <div class="form-group">
              <p>Full Name : <strong>{{profileStatus?.fullName}}</strong></p>
            </div>
            <div class="form-group">
              <p>Nationality : <strong>{{profileStatus?.nationality}}</strong></p>
            </div>
            <div class="form-group">
              <p>Date Of Birth : <strong>{{profileStatus?.dateOfBirth |date:'shortDate'}}</strong></p>
            </div>
            <div class="form-group">
              <p>Date of Expiry : <strong>{{profileStatus?.dateOfExpiry |date:'shortDate'}}</strong></p>
            </div>
            <div class="form-group">
              <p>Status : <strong>{{profileStatus?.status }}</strong></p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="listingformat paymenthistory">
          <span>Connection Preference</span>
          <div class="tabledatawrap table-responsive">
            <div class="form-group">
              <p>Connection Status : <select (change)="matchStatus($event)">
                  <option value="">All</option>
                  <option value="mutual">Mutual</option>
                  <option value="sent">Sent</option>
                  <option value="received">Received</option>
                  <option value="maybe">May be</option>
                  <option value="pass">Pass</option>
                  <option value="pending">Pending</option>
                </select></p>
            </div>
            <div class="form-group">
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>User Name</th>
                    <th>Email</th>
                    <th>Phone Number</th>
                    <th>Connection Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of dataMeet">
                    <td>{{item?.date}}</td>
                    <td>
                      <ng-container *ngIf="connectionProfileId(item) as otherUserId; else plainName">
                        <a [href]="connectionProfileUrl(otherUserId)" target="_blank" rel="noopener noreferrer">
                          {{item?.name}}
                        </a>
                      </ng-container>
                      <ng-template #plainName>{{item?.name}}</ng-template>
                    </td>
                    <td>{{item?.email}}</td>
                    <td>{{item?.phone}}</td>
                    <td>{{item?.match_status}}</td>
                    <td>
                      <div class="" *ngIf="item.match_status =='Mutual';else dissablebtn" (click)="meetinfoData(item)">
                        <button type="button" class="btn dtlsbtn" data-toggle="modal" data-target="#prefernceModal">Meet
                          Detail</button>
                      </div>
                      <ng-template #dissablebtn>
                        <button type="button" class="btn dissablebtn" disabled>Meet Detail</button>
                      </ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Middle Content CSS End Here  -->

<!--Match Preference Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="prefernceModal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog animated fadeInDown">
    <div class="modal-content">
      <div class="modal-header">
        <div class="popupheding">
          Meet Details
        </div> <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
      </div>
      <div class="modal-body">
        <div class="listingformat">
          <div class="tabledatawrap table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Venue Name</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Meet Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of matchData">
                  <td>{{item?.venue_name}}</td>
                  <td>{{item?.date}}</td>
                  <td>{{item?.time}}</td>
                  <td>{{item?.meet_status}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Match Preference Moda -->

<!-- Remove From Auto Approval Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="removeFromAutoApprovalModal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog animated fadeInDown">
    <div class="modal-content">
      <div class="modal-header">
        <div class="popupheding">
          Confirm Action
        </div> <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
      </div>
      <div class="modal-body">
        <div class="filtercard">
          <p>This will move the user back to the approval list. Please select a reason:</p>

          <div class="form-group">
            <select class="form-control" [(ngModel)]="removalReason">
              <option value="" disabled selected>Select Reason</option>
              <option value="Image">Image</option>
              <option value="Nationality">Nationality</option>
              <option value="Occupation">Occupation</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div class="form-group" *ngIf="removalReason === 'Other'">
            <textarea class="form-control" rows="3" placeholder="Enter reason..."
              [(ngModel)]="otherRemovalReason"></textarea>
          </div>

          <div class="common_btn">
            <button data-dismiss="modal">Cancel</button>
            <button (click)="confirmRemoveFromAutoApproval()" id="closeRemoveAutoApproval"
              [disabled]="!removalReason || (removalReason === 'Other' && !otherRemovalReason)">
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Notification Popup -->
<div class="modal fade bd-example-modal-sm common_modal" id="deletModal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog animated fadeInDown">
    <div class="modal-content">
      <div class="modal-header">
        <div class="popupheding">
          Send Notification
        </div> <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
      </div>
      <div class="modal-body">
        <div class="filtercard" [formGroup]="addnotificationForm">
          <div class="form-group full-input-wrap">
            <p>
              <span class="your-name"><input name="your-name" placeholder="Title" value="" size="40"
                  class="form-control" type="text" autocomplete="off" autocomplete="off" formControlName="Title"
                  [ngClass]="{
                            'is-invalid': submitted && addf['Title'].errors
                          }" />
                <div class="errorDiv" *ngIf="submitted && addf['Title'].errors" class="invalid-feedback">
                  <div class="error" *ngIf="addf['Title'].errors['required']">
                    Title is required
                  </div>
                </div>
              </span>
            </p>
          </div>
          <div class="form-group full-input-wrap">
            <p>
              <span>
                <textarea class="form-control" autocomplete="off" placeholder="Body" name="" id="" autocomplete="off"
                  cols="30" rows="10" formControlName="Body" [ngClass]="{
                          'is-invalid': submitted && addf['Body'].errors
                        }"></textarea>
                <div class="errorDiv" *ngIf="submitted && addf['Body'].errors" class="invalid-feedback">
                  <div class="error" *ngIf="addf['Body'].errors['required']">
                    Body is required
                  </div>
                </div>
              </span>
            </p>
          </div>
          <div class="form-group">
            <button class="btn btn-block" (click)="onSubmit()">Send</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Notification Popup -->


<!-- Upload Photo Shown Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="photoModal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog animated fadeInDown">
    <div class="modal-content">
      <div class="modal-header">
        <div class="popupheding">
          Upload Image
        </div> <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
      </div>
      <div class="modal-body">
        <div class="uploadimge">
          <img src="{{this.uploadImg}}">
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Upload Photo Shown Modal -->

<!-- Edit Tier Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="editTierModal" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">
  <div class="modal-dialog animated fadeInDown">
    <div class="modal-content">
      <div class="modal-header">
        <div class="popupheding">
          Edit Tier
        </div> <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
      </div>
      <div class="modal-body">
        <div class="filtercard">
          <form>
            <div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group full-input-wrap">
                    <p>
                      <label>Tier <span>*</span></label>
                      <span>
                        <select2 [data]="dataTiersList" [value]="tier" minCountForSearch="0" noResultMessage="No result"
                          (update)="updateTier($event)">
                        </select2>
                        <div class="errorDiv" *ngIf="submitted && !tier" class="invalid-feedback">
                          <div class="error">
                            Field is required
                          </div>
                        </div>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="common_btn">
              <button data-dismiss="modal">Back</button>
              <button id="close" (click)="onTierSubmit()">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Reject modal -->
<app-reject-modal [id]="rejectModalId" [modalEvent]="rejectEmitter"
  (rejectUser)="rejectUser($event)"></app-reject-modal>

<!-- Unapprove modal -->
<app-unapprove-modal [id]="unApproveModalId" [modalEvent]="unApproveEmitter"
  (unapproveUser)="unapproveUser($event)"></app-unapprove-modal>

<!-- Approve modal -->
<app-approve-modal [id]="approveModalId" [modalEvent]="approveEmitter"
  (approveUser)="approveUser()"></app-approve-modal>

<tier2-app-approve-modal [id]="tier2ApproveModalId" [modalEvent]="tier2ApproveEmitter"
  (approveUser)="approveTier2Unapprovedf()"></tier2-app-approve-modal>

<!-- Scout Membership Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="scoutModal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 500px; width: 90%;">
    <div class="modal-content">
      <div class="modal-header">
        <div class="popupheding">
          Scout Membership
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
      </div>
      <div class="modal-body" style="padding: 20px;">
        <div style="display: flex; flex-direction: column; gap: 20px;">
          <p style="margin: 0; font-size: 16px; line-height: 1.5;">Are you sure you want to give a 6-month membership to
            this user?</p>
          <div class="common_btn" style="display: flex; justify-content: space-between; gap: 10px;">
            <button data-dismiss="modal" style="flex: 1; padding: 8px 16px; cursor: pointer;">No</button>
            <button (click)="confirmScoutMembership()" style="flex: 1; padding: 8px 16px; cursor: pointer;">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Edit Customer Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="editCustomerModal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 600px; width: 90%;">
    <div class="modal-content">
      <div class="modal-header">
        <div class="popupheding">
          Edit Customer Details
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
      </div>
      <div class="modal-body" style="padding: 20px;">
        <div class="filtercard" [formGroup]="editCustomerForm">
          <div class="form-group full-input-wrap">
            <p>
              <label>Name</label>
              <span>
                <input class="form-control" placeholder="Enter customer name..." type="text" formControlName="name">
              </span>
            </p>
          </div>

          <div class="form-group full-input-wrap">
            <p>
              <label>Occupation</label>
              <span>
                <input class="form-control" placeholder="Enter occupation..." type="text" formControlName="occupation">
              </span>
            </p>
          </div>

          <div class="form-group full-input-wrap">
            <p>
              <label>Connection Pitch</label>
              <span>
                <textarea class="form-control" placeholder="Enter the connection pitch here..." rows="4"
                  formControlName="connection_pitch">
                </textarea>
              </span>
            </p>
          </div>

          <div class="common_btn" style="display: flex; justify-content: space-between; gap: 10px; margin-top: 20px;">
            <button data-dismiss="modal" style="flex: 1; padding: 8px 16px; cursor: pointer;">Cancel</button>
            <button (click)="onEditCustomerSubmit()"
              style="flex: 1; padding: 8px 16px; cursor: pointer;">Update</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Audio Confirmation Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="deleteAudioModal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 500px; width: 90%;">
    <div class="modal-content">
      <div class="modal-header">
        <div class="popupheding">
          Delete Audio
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
      </div>
      <div class="modal-body" style="padding: 20px;">
        <div style="display: flex; flex-direction: column; gap: 20px;">
          <p style="margin: 0; font-size: 16px; line-height: 1.5;">Are you sure you want to delete this audio? This
            action cannot be undone.</p>
          <div class="common_btn" style="display: flex; justify-content: space-between; gap: 10px;">
            <button data-dismiss="modal" style="flex: 1; padding: 8px 16px; cursor: pointer;">Cancel</button>
            <button (click)="confirmDeleteAudio()"
              style="flex: 1; padding: 8px 16px; cursor: pointer; background-color: #dc3545; color: white;">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Move to TIER2 Confirmation Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="moveToTier2Modal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 500px; width: 90%;">
    <div class="modal-content">
      <div class="modal-header">
        <div class="popupheding">
          Move to TIER2
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
      </div>
      <div class="modal-body" style="padding: 20px;">
        <div style="display: flex; flex-direction: column; gap: 20px;">
          <p style="margin: 0; font-size: 16px; line-height: 1.5;">Are you sure you want to move this user to TIER2?
            This will associate the user with TIER2 tier and update their status.</p>
          <div class="common_btn" style="display: flex; justify-content: space-between; gap: 10px;">
            <button data-dismiss="modal"
              style="flex: 1; padding: 8px 16px; cursor: pointer; background-color: transparent; border: 1px solid #6c757d; color: #6c757d;">Cancel</button>
            <button (click)="confirmMoveToTier2()"
              style="flex: 1; padding: 8px 16px; cursor: pointer; background-color: #343a40; color: white;">Move to
              TIER2</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>